/* Heritage Boots theme — minimal interactive JS */
(function () {
  'use strict';

  /* ---- Mobile nav ---- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('.mobile-nav');
    var overlay = document.querySelector('.nav-overlay');
    var close = document.querySelector('.mobile-nav__close');
    if (!toggle || !nav) return;
    function open() { nav.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function shut() { nav.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    if (overlay) overlay.addEventListener('click', shut);
  }

  /* ---- Product gallery thumbs ---- */
  function initGallery() {
    var main = document.querySelector('[data-main-image]');
    var thumbs = document.querySelectorAll('[data-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full) main.src = full;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---- Quantity stepper ---- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-qty-btn') === 'plus' ? 1 : -1;
          var min = parseInt(input.getAttribute('min'), 10);
          if (isNaN(min)) min = 1;
          var val = Math.max(min, (parseInt(input.value, 10) || min) + step);
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---- Modal (size chart, etc.) ---- */
  function initModal() {
    document.querySelectorAll('[data-modal-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var m = document.querySelector('[data-modal="' + btn.getAttribute('data-modal-open') + '"]');
        if (m) { m.hidden = false; document.body.style.overflow = 'hidden'; }
      });
    });
    document.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        var m = el.closest('.modal');
        if (m) { m.hidden = true; document.body.style.overflow = ''; }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.modal:not([hidden])').forEach(function (m) {
          m.hidden = true; document.body.style.overflow = '';
        });
      }
    });
  }

  /* ---- Variant selection via option pills ----
     Variant data is read from a DOM map of data-* attributes (no JSON.parse,
     so it can't silently fail). Clicking a pill always updates the active
     state AND the hidden [name="id"], so add-to-cart uses the real variant. */
  function initVariants() {
    var root = document.querySelector('[data-product]');
    if (!root) return;
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
    if (!groups.length) return;

    var mapEl = root.querySelector('[data-variant-map]') || document.querySelector('[data-variant-map]');
    var money = mapEl ? (mapEl.getAttribute('data-money') || '${{amount}}') : '${{amount}}';
    var variants = mapEl ? Array.prototype.map.call(mapEl.querySelectorAll('[data-vid]'), function (s) {
      return {
        id: s.getAttribute('data-vid'),
        options: (s.getAttribute('data-opts') || '').split('||'),
        available: s.getAttribute('data-avail') === 'true',
        price: parseInt(s.getAttribute('data-price'), 10) || 0,
        cprice: parseInt(s.getAttribute('data-cprice'), 10) || 0,
        img: s.getAttribute('data-img') || ''
      };
    }) : [];

    var form = root.querySelector('form[action*="/cart/add"]') || root.querySelector('[data-product-form]') || root;
    var idField = form.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var curText = priceEl && priceEl.querySelector('.cur') ? priceEl.querySelector('.cur').textContent : '';
    var addBtn = form.querySelector('[data-add]');
    var mainImg = root.querySelector('[data-main-image]');

    var chosen = [];
    groups.forEach(function (g) {
      var idx = parseInt(g.getAttribute('data-option-index'), 10);
      var active = g.querySelector('.opt-pill.is-active') || g.querySelector('.opt-pill');
      chosen[idx] = active ? active.getAttribute('data-value') : null;
      g.querySelectorAll('.opt-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          g.querySelectorAll('.opt-pill').forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          chosen[idx] = pill.getAttribute('data-value');
          updateVariant();
        });
      });
    });

    function fmt(cents) {
      var n = cents / 100;
      var v = n.toFixed(2);
      var withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return money
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(n).toLocaleString('en-US'))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(n)))
        .replace(/\{\{\s*amount\s*\}\}/, v);
    }

    function exactVariant() {
      if (!variants.length) return null;
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
    }

    function markAvailability() {
      if (!variants.length) return;
      groups.forEach(function (g) {
        var idx = parseInt(g.getAttribute('data-option-index'), 10);
        g.querySelectorAll('.opt-pill').forEach(function (pill) {
          var val = pill.getAttribute('data-value');
          var ok = variants.some(function (v) {
            if (!v.available) return false;
            if (v.options[idx] !== val) return false;
            return v.options.every(function (o, i) { return i === idx || chosen[i] == null || o === chosen[i]; });
          });
          pill.classList.toggle('is-soldout', !ok);
        });
      });
    }

    function updateVariant() {
      markAvailability();
      var v = exactVariant();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-label-sold'); }
        return;
      }
      if (idField) idField.value = v.id;
      if (priceEl) {
        var inner;
        if (v.cprice && v.cprice > v.price) {
          inner = '<span class="price"><s>' + fmt(v.cprice) + '</s><span class="on-sale">' + fmt(v.price) + '</span></span>';
        } else {
          inner = '<span class="price">' + fmt(v.price) + '</span>';
        }
        if (curText) inner += ' <span class="cur">' + curText + '</span>';
        priceEl.innerHTML = inner;
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-sold');
      }
      if (mainImg && v.img) mainImg.src = v.img;
    }

    updateVariant();
  }

  /* ---- Cart drawer (AJAX) ---- */
  function initCart() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var footEl = drawer.querySelector('[data-cart-foot]');
    var totalEl = drawer.querySelector('[data-cart-total]');
    var money = drawer.getAttribute('data-money') || '${{amount}}';

    function fmt(cents) {
      var n = cents / 100;
      var v = n.toFixed(2);
      var withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return money
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(n).toLocaleString('en-US'))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(n)))
        .replace(/\{\{\s*amount\s*\}\}/, v);
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function thumb(url) {
      if (!url) return '';
      return url.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_160x$1$2');
    }

    function open() {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 300);
    }

    function updateCounts(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.setAttribute('data-count', count); });
      document.querySelectorAll('[data-cart-count-text]').forEach(function (el) { el.textContent = count; });
    }

    function render(cart) {
      updateCounts(cart.item_count);
      if (!cart.items || !cart.items.length) {
        itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>' + esc(drawer.getAttribute('data-empty') || 'Tu carrito está vacío') + '</p><a href="/collections/all" class="btn btn--cta" data-cart-close>Seguir comprando</a></div>';
        footEl.hidden = true;
        return;
      }
      footEl.hidden = false;
      totalEl.textContent = fmt(cart.total_price);
      itemsEl.innerHTML = cart.items.map(function (it) {
        var opts = (it.options_with_values || [])
          .filter(function (o) { return o.value && o.value !== 'Default Title'; })
          .map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' · ');
        return '<div class="cart-line" data-key="' + esc(it.key) + '">'
          + '<a href="' + esc(it.url) + '" class="cart-line__img"><img src="' + esc(thumb(it.image)) + '" alt="" loading="lazy"></a>'
          + '<div class="cart-line__info">'
          + '<a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>'
          + (opts ? '<div class="cart-line__opts">' + opts + '</div>' : '')
          + '<button type="button" class="cart-line__remove" data-cart-remove>Quitar</button>'
          + '</div>'
          + '<div class="cart-line__right">'
          + '<span class="cart-qty"><button type="button" data-cart-minus aria-label="Restar">&minus;</button>'
          + '<input type="text" value="' + it.quantity + '" data-cart-qty readonly aria-label="Cantidad">'
          + '<button type="button" data-cart-plus aria-label="Sumar">+</button></span>'
          + '<div class="cart-line__price">' + fmt(it.final_line_price) + '</div>'
          + '</div>'
          + '</div>';
      }).join('');
    }

    function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
    function refresh() { return getCart().then(render); }
    function change(key, qty) {
      itemsEl.classList.add('is-busy');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) { render(cart); itemsEl.classList.remove('is-busy'); });
    }

    // open via cart toggles
    document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); open(); refresh(); });
    });
    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', close); });
    drawer.addEventListener('click', function (e) { if (e.target.closest('[data-cart-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });

    // line item qty/remove (delegated)
    itemsEl.addEventListener('click', function (e) {
      var line = e.target.closest('[data-key]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var input = line.querySelector('[data-cart-qty]');
      var cur = input ? (parseInt(input.value, 10) || 0) : 0;
      if (e.target.closest('[data-cart-remove]')) change(key, 0);
      else if (e.target.closest('[data-cart-plus]')) change(key, cur + 1);
      else if (e.target.closest('[data-cart-minus]')) change(key, Math.max(0, cur - 1));
    });

    // checkout
    var co = drawer.querySelector('[data-cart-checkout]');
    if (co) co.addEventListener('click', function () { window.location.href = '/checkout'; });

    // AJAX add-to-cart from the product form
    var pform = document.querySelector('form[action*="/cart/add"]') || document.querySelector('[data-product-form]');
    if (pform) {
      pform.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = pform.querySelector('[data-add]') || pform.querySelector('[type="submit"]');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = '…'; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(pform) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (btn) { btn.disabled = false; btn.textContent = label; }
            if (!res.ok) { window.location.href = '/cart'; return; }
            open();
            return refresh();
          })
          .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } window.location.href = '/cart'; });
      });
    }
  }

  /* ---- Predictive search overlay ---- */
  function initSearch() {
    var ov = document.querySelector('[data-search]');
    if (!ov) return;
    var input = ov.querySelector('[data-search-input]');
    var def = ov.querySelector('[data-search-default]');
    var resultsBox = ov.querySelector('[data-search-results]');
    var timer = null;

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function open() {
      ov.hidden = false; document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { ov.classList.add('is-open'); if (input) input.focus(); });
    }
    function close() {
      ov.classList.remove('is-open'); document.body.style.overflow = '';
      setTimeout(function () { ov.hidden = true; }, 280);
    }
    function showDefault() {
      if (def) def.hidden = false;
      if (resultsBox) { resultsBox.hidden = true; resultsBox.innerHTML = ''; }
    }
    function render(products, q) {
      if (def) def.hidden = true;
      if (!resultsBox) return;
      resultsBox.hidden = false;
      if (!products.length) {
        resultsBox.innerHTML = '<p class="search-ov__empty">Sin resultados para “' + esc(q) + '”.</p>';
        return;
      }
      resultsBox.innerHTML = products.map(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        var sub = p.product_type || p.vendor || '';
        return '<a class="sresult" href="' + esc(p.url) + '">'
          + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '')
          + '<span class="sresult__title">' + esc(p.title) + '</span>'
          + (sub ? '<span class="sresult__sub">' + esc(sub) + '</span>' : '')
          + '</a>';
      }).join('');
    }
    function query(q) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, q);
        })
        .catch(function () {});
    }

    document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    ov.querySelectorAll('[data-search-close]').forEach(function (el) { el.addEventListener('click', close); });
    ov.addEventListener('click', function (e) { if (!e.target.closest('.search-ov__inner')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) close(); });

    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { showDefault(); return; }
        timer = setTimeout(function () { query(q); }, 220);
      });
    }
  }

  /* ---- Mobile facets toggle ---- */
  function initFacets() {
    document.querySelectorAll('[data-facets-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.closest('[data-facets]');
        if (f) { if (f.hasAttribute('data-open')) f.removeAttribute('data-open'); else f.setAttribute('data-open', ''); }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initGallery();
    initQty();
    initModal();
    initVariants();
    initCart();
    initSearch();
    initFacets();
  });
})();
